import React, { Component } from 'react';

import CheckingOffenseFormImage from './CheckingOffenseFormImage'
import { Form, Input, InputNumber, Button, Modal, Select, Divider, Switch, Icon, message } from 'antd';

const FormItem = Form.Item;

class CheckingOffenseForm extends Component {

  state = {
    modalVisible: false,
    data: null,
    imgData: null
  }

  form = null;

  componentWillReceiveProps(nextProps) {    
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Registrační značka" >
          {getFieldDecorator('plate', {
            initialValue: this.props.initialValues && this.props.initialValues.plate
              ? this.props.initialValues.plate
              : null,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        {this.props.initialValues && this.props.initialValues.plateDetailImage
          ? <FormItem
            {...formItemLayout}
            label="Detail RZ" >
              <CheckingOffenseFormImage
                fileName={this.props.initialValues.plateDetailImage.fileName} />
          </FormItem>
          : null}
        {this.props.type && this.props.type !== 'modal'
          ? <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">Uložit</Button>
          </FormItem>
          : null}
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          className={'cstm-modal-form'}
          width={700}
          title="Editace záznamu o provedené kontrole"
          visible={this.state.modalVisible}
          maskClosable={false}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          okText="Uložit"
          onOk={this.handleSubmit} >
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const wrapped = Form.create()(CheckingOffenseForm);

export default wrapped;


// WEBPACK FOOTER //
// ./src/components/CheckingOffenseForm.js